<template>
  <div
    v-if="$root.siteRenderer != 'pc'"
    class="left-pane mobile"
    :class="{collapsed: $root.isMenuCollapsed}"
  >
    <Logo/>
    <SearchBox v-model="filterMenuKeyword" v-if="isShowMenuSearchBox"/>
    <el-menu mode="vertical" ref="menu"
      :collapse="false"
      :router="false"
      :default-active="currentRoutePath"
      :default-openeds="openedMenus"
      @select="onSelectMenuItem"
      class="left-menu"
    >
      <McMenuItem v-for="(item, index) in filteredMenu" :meta="item" :key="index"/>
      <li v-if="!(filteredMenu && filteredMenu.length)" class="empty-content">
        未找到菜单
      </li>
    </el-menu>
  </div>
</template>


<script>
  import siteOptions from '@/config/index'
  import { filterMenusByKeyword, getMenusLeafCount, getMenusOpenedIndexes } from '@/framework/utils/layout'
  import { mainMenuConfig } from '@/config/menu';
  import { filterMenu } from '@/framework/utils/perm'
  import Logo from '@/framework/components/Logo.vue'
  import McMenuItem from '@/framework/components/McMenuItem'
  import SearchBox from '@/framework/components/SearchBox'

  export default {
    name: 'MobileSideBar',
    data() {
      return {
        mainMenuConfig : [],
        currentRoutePath: this.$route.fullPath || '/',
        filterMenuKeyword: ''
      }
    },
    watch: {
      '$route': {
        handler(){
          this.currentRoutePath = this.$route.fullPath
        }
      }
    },
    computed: {
      filteredMenu() {
        return filterMenusByKeyword(this.mainMenuConfig, this.filterMenuKeyword)
      },
      isShowMenuSearchBox(){
        return siteOptions['isShowMenuSearchBox'] && !this.$root.isMenuCollapsed &&
          ( this.menusCount > siteOptions['whenShowMenuSearchBox'] || this.filterMenuKeyword )
      },
      menusCount(){
        return getMenusLeafCount(this.filteredMenu)
      },
      openedMenus(){
        if(this.filterMenuKeyword){
          return getMenusOpenedIndexes(this.filteredMenu)
        } else {
          return []
        }
      }
    },
    mounted(){
      filterMenu(mainMenuConfig).then(menus=>{
        this.mainMenuConfig = menus
      })
    },
    methods: {
      onSelectMenuItem(path){
        if(path && path.indexOf('http') === 0){
          this.$refs.menu.updateActiveIndex(this.$route.fullPath)
          window.open(path)
        } else {
          this.$router.push({
            path: path,
            query: {}
          })
          this.currentRoutePath = path
        }
        this.$root.setMenuCollapsedState(!this.$root.isMenuCollapsed)
      }
    },
    components: {
      Logo, McMenuItem, SearchBox
    }
  }
</script>
